module.exports = __webpack_public_path__ + "img/Interests.32a7c512.svg";